"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usersListStore = void 0;
const api_1 = require("client/api");
const ui_1 = require("client/components/ui");
const mobx_1 = require("mobx");
const store_1 = require("../../store");
class UsersListStore {
    constructor() {
        this.users = {
            value: []
        };
        this.editUser = {};
        this.groups = { value: [] };
        //C-097 users pagination
        this.totalProviderPage = 1;
        this.currentPage = 1;
        this.usersLoading = false;
        //C-097 users pagination
        this.loadUsers = async (query = {}) => {
            this.usersLoading = true; // C-097 
            this.users = { loading: true, value: this.users.value };
            const result = await api_1.UserEndpoint.list.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.users = { error: result.code };
            }
            else {
                this.users = { value: result.users };
                this.totalProviderPage = result.totalPages; //C-097 users pagination
                this.currentPage = result.currentPage; //C-097 users pagination      
                this.usersLoading = false; //C-097 users pagination
            }
        };
        // B-111.1_PROD
        this.loadAllUsers = async (query = { start: 0, count: null, showDisabled: true }) => {
            this.users = { loading: true, value: this.users.value };
            const result = await api_1.UserEndpoint.list.apiCall({
                query
            });
            if (api_1.isError(result)) {
                this.users = { error: result.code };
            }
            else {
                this.users = { value: result.users };
            }
        };
        this.loadGroups = async () => {
            this.groups = { loading: true, value: this.groups.value };
            const result = await api_1.UserEndpoint.groups.apiCall();
            if (api_1.isError(result)) {
                this.groups = { error: result.code };
            }
            else {
                this.groups = { value: result.groups };
            }
        };
        this.createUser = async (user) => {
            this.editUser = { loading: true, status: ui_1.FormStatus.Saving };
            const result = await api_1.UserEndpoint.create.apiCall(null, { user });
            if (api_1.isError(result)) {
                console.log("result: ", result);
                this.editUser = { error: result.code, status: ui_1.FormStatus.Error };
                return false;
            }
            else {
                this.editUser = { status: ui_1.FormStatus.Saved };
                return result.user;
            }
        };
        this.saveUser = async (user) => {
            this.editUser = { loading: true, status: ui_1.FormStatus.Saving };
            const result = await api_1.UserEndpoint.save.apiCall(null, { user });
            if (api_1.isError(result)) {
                this.editUser = { error: result.code, status: ui_1.FormStatus.Error };
                return false;
            }
            else {
                this.editUser = { status: ui_1.FormStatus.Saved };
                // If this is the current user, then update it in MobX
                if (store_1.usersStore.user.value) {
                    if (result.user.id === store_1.usersStore.user.value.id) {
                        store_1.usersStore.user.value = Object.assign({}, result.user);
                    }
                }
                return result.user;
            }
        };
        this.changePassword = async (userId, password) => {
            this.editUser = { loading: true, status: ui_1.FormStatus.Saving };
            const result = await api_1.UserEndpoint.changePassword.apiCall(null, {
                userId,
                password
            });
            if (api_1.isError(result)) {
                this.editUser = { error: result.code, status: ui_1.FormStatus.Error };
                return false;
            }
            else {
                this.editUser = { status: ui_1.FormStatus.Saved };
                return result;
            }
        };
        this.deleteUser = async (user) => {
            this.editUser = { loading: true };
            const result = await api_1.UserEndpoint.remove.apiCall({
                params: { id: user.id }
            });
            if (api_1.isError(result)) {
                this.editUser = { error: result.code, status: ui_1.FormStatus.Error };
            }
            else {
                this.editUser = {};
                this.loadUsers();
            }
        };
    }
}
__decorate([
    mobx_1.observable
], UsersListStore.prototype, "users", void 0);
__decorate([
    mobx_1.observable
], UsersListStore.prototype, "editUser", void 0);
__decorate([
    mobx_1.observable
], UsersListStore.prototype, "groups", void 0);
__decorate([
    mobx_1.observable
], UsersListStore.prototype, "totalProviderPage", void 0);
__decorate([
    mobx_1.observable
], UsersListStore.prototype, "currentPage", void 0);
__decorate([
    mobx_1.observable
], UsersListStore.prototype, "usersLoading", void 0);
__decorate([
    mobx_1.action
], UsersListStore.prototype, "loadUsers", void 0);
__decorate([
    mobx_1.action
], UsersListStore.prototype, "loadAllUsers", void 0);
__decorate([
    mobx_1.action
], UsersListStore.prototype, "loadGroups", void 0);
__decorate([
    mobx_1.action
], UsersListStore.prototype, "createUser", void 0);
__decorate([
    mobx_1.action
], UsersListStore.prototype, "saveUser", void 0);
__decorate([
    mobx_1.action
], UsersListStore.prototype, "changePassword", void 0);
__decorate([
    mobx_1.action
], UsersListStore.prototype, "deleteUser", void 0);
exports.usersListStore = new UsersListStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/users/modules/users-list/store.ts
// module id = 556
// module chunks = 0